// extracted by mini-css-extract-plugin
export var contentPage = "content-module--content-page--jWE0B";
export var contentPage__hero = "content-module--content-page__hero--LrfGB";
export var contentPage__gradient = "content-module--content-page__gradient--zj0PI";
export var contentPage__gradient_tablet = "content-module--content-page__gradient_tablet--Dr778";
export var contentPage__gradient_mobile = "content-module--content-page__gradient_mobile--+eIPz";
export var contentPage__title = "content-module--content-page__title--I7Wv2";
export var contentPage__desc = "content-module--content-page__desc--PgwUA";
export var contentPage__content = "content-module--content-page__content--2hEms";